import { VideoStoreActionContext } from './initializer';
import { videosApi } from '@/scripts/webcall/v3/videos';
import { assertNotNull, createPlayerErrorWithIssuer } from '../helpers/helper';
import { Model } from '@viddsee/server-api-client';
import { VideoBlockedError, VideoRatedContentError, VideoRatedContentMissingBirthdayError, VideoRatedContentMissingPinError, VideoRatedContentMissingSetPinError } from '../state/errors';
import { SetVideoPlayerErrorPayload } from '../mutations/setVideoPlayerError';

const asBlockingError = createPlayerErrorWithIssuer(VideoBlockedError);

export const setBlockingError = (context: VideoStoreActionContext, payload: SetVideoPlayerErrorPayload | null): void => {
  context.commit('setVideoPlayerError', asBlockingError(payload));
};

const getFlowPresenter = ({ status, message }: Model.Video.CanWatchWithPinResponse): SetVideoPlayerErrorPayload | null => {
  switch (status) {
    case 'can_watch':
      return null;
    case 'need_login':
      return {
        error: new VideoRatedContentError(message),
      };
    case 'need_birthday':
      return {
        error: new VideoRatedContentMissingBirthdayError(message),
      };
    case 'need_pin' :
      return {
        error: new VideoRatedContentMissingPinError(message),
      };
    case 'need_set_pin' :
      return {
        error: new VideoRatedContentMissingSetPinError(message),
      };
    default:
      return {
        error: new VideoBlockedError(message),
      };
  }
};

export const handleVideoCanWatchFlow = async(context: VideoStoreActionContext): Promise<boolean> => {
  const video = assertNotNull(context.state.video);
  setBlockingError(context, null);

  try {
    const { data: response } = await videosApi.getCanWatchWithPin({ videoId: video.id }, undefined, { pin: '' });
    setBlockingError(context, getFlowPresenter(response));
    return response.status === 'can_watch';
  } catch (error) {
    // Likely server / network error. Allow user to try again
    setBlockingError(context, {
      error: new VideoBlockedError(error.message),
    });
    return false;
  }
};

export const checkContentWatchability = async(context: VideoStoreActionContext): Promise<void> => {
  const canWatch = await handleVideoCanWatchFlow(context);

  // TODO: Remove as any after upgrading to typescript 4
  context.commit('setCanWatch', canWatch as any);
};
